import React from 'react';
import * as S from './flight-fares.styles';
import FareBlock from './fare-block/fare-block';
import useCarousel from '@stencil/use-carousel';

const Fare = ({ faresData, isDweb = false }) => {
  if (!faresData) {
    return null;
  }
  let threshold = isDweb ? 5 : 2;
  const { dataList, increment, decrement } = useCarousel(faresData, threshold, true);

  return <FareBlock data={dataList} handlePrevClick={decrement} handleNextClick={increment} />;
};

const FlightFares = ({ flightFares, isDweb = false }) => {
  return (
    <S.FlightsRoute className="flexCol">
      {flightFares &&
        flightFares.map((flightFare, index) => (
          <S.FlightFareChart key={index} className="flexCol">
            <div className="dF justifyBetween padB5">
              <S.RouteHd>{flightFare.heading}</S.RouteHd>
              <a href={flightFare.link}>
                <S.BookButton>
                  <S.RouteBook>Book</S.RouteBook>
                </S.BookButton>
              </a>
            </div>
            <Fare faresData={flightFare.faresData} isDweb={isDweb} />
          </S.FlightFareChart>
        ))}
    </S.FlightsRoute>
  );
};

export default FlightFares;
